var $52d3f74100ed95d5$exports = {};
$52d3f74100ed95d5$exports = {
    "help": `Pomoc`,
    "info": `Informacja`
};


export {$52d3f74100ed95d5$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
